import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Mail } from "lucide-react";
import { emailStatus } from "../../api/platformRevenue";
import { NeuCard } from "../../components/neu/Neu";

// SES delivery diagnostics: shows immediately why emails fail in a given environment.
export const EmailStatusCard = () => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    emailStatus().then(setData).catch(() => setData({ ok: false, error: "unreachable" }));
  }, []);

  if (!data) return null;
  const dash = (value) => (data.diagnostics_blocked ? "—" : value);
  const rows = [
    ["region", data.region],
    ["sender", data.from_email],
    ["verified", dash(data.sender_identity_verified ? t("app.yes") : t("app.no"))],
    ["production", dash(data.production_access ? t("app.yes") : t("app.no"))],
    ["quota", dash(`${data.sent_last_24h ?? 0} / ${data.daily_quota ?? 0}`)],
    ["configSet", data.configuration_set || "—"],
  ];

  return (
    <NeuCard data-testid="email-status-card">
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-3">
          <Mail className="h-5 w-5 text-primary" />
          <div>
            <h2 className="text-lg font-black">{t("emailStatus.title")}</h2>
            <p className="text-xs text-muted-foreground">{t("emailStatus.subtitle")}</p>
          </div>
        </div>
        <span
          className={`rounded-xl px-3 py-1 text-xs font-bold ${data.ok ? "text-success" : "text-destructive"}`}
          data-testid="email-status-flag"
        >
          {data.ok ? t(data.diagnostics_blocked ? "emailStatus.limited" : "emailStatus.ok") : t("emailStatus.failing")}
        </span>
      </div>
      <div className="mt-4 grid grid-cols-2 gap-3 lg:grid-cols-3">
        {rows.map(([key, value]) => (
          <div key={key} className="neu-in rounded-2xl p-3" data-testid={`email-${key}`}>
            <p className="text-[10px] tracking-normal text-muted-foreground">{t(`emailStatus.${key}`)}</p>
            <p className="mt-1 truncate font-mono text-sm font-semibold">{value}</p>
          </div>
        ))}
      </div>
      {data.error ? (
        <p className="mt-3 font-mono text-xs text-destructive" data-testid="email-error">
          {data.error}
        </p>
      ) : null}
    </NeuCard>
  );
};
